const DEV = `https://cjs-api-parent-backend-java-dev-dt.io.mlj130.com`;
const TEST = `https://cjs-api-backend-java-test-dt.io.mlj130.com`;
const PRODUCTION = `https://cjs-api-backend-java.io.mlj130.com`;
const DOMAIN = process.env.PREACT_APP_ENV === "development" ? TEST : PRODUCTION;
const ATEST=`https://c-account-api-backend-java-test-dt.io.mlj130.com`;
const APRODUCTION=`https://c-account-api-backend-java.io.mlj130.com`;
const APATH=process.env.PREACT_APP_ENV === "development" ?ATEST:APRODUCTION;

const TLJ_TEST = `https://tlj-api-backend-java-test-dt.io.mlj130.com`;

const TLJ_PROD = `https://tlj-api-backend-java.io.mlj130.com`;

const TLJ_DOMAIN =
  process.env.PREACT_APP_ENV === "development" ? TLJ_TEST : TLJ_PROD;

const MEMBER_CENTER_TEST = `https://member-center-front-end-test-dt.io.mlj130.com`;
const MEMBER_CENTER_PROD = `https://member-center-front-end.io.mlj130.com/`;

const MEMBER_CENTER_DOMAIN =
  process.env.PREACT_APP_ENV === "development"
    ? MEMBER_CENTER_TEST
    : MEMBER_CENTER_PROD;

const D11_PROD = `https://d11-web-front.io.mlj130.com`;
const D11_TEST = `https://d11-web-front-test-dt.io.mlj130.com`;

const D11_DOMAIN =
  process.env.PREACT_APP_ENV === `development` ? D11_TEST : D11_PROD;

const D11_BACK_END_TEST = `https://d11-api-backend-java-test-dt.io.mlj130.com`;
const D11_BACK_END_PROD = ` https://d11-api-backend-java.io.mlj130.com`;
const D11_BACK_END =
  process.env.PREACT_APP_ENV === `development`
    ? D11_BACK_END_TEST
    : D11_BACK_END_PROD;
const TEST_LIVE=`https://secret-list.io.mlj130.com/lt`;
const PRODUCTION_LIVE=`https://secret-list.io.mlj130.com/lt`;
const DOMAIN_LIVE = process.env.PREACT_APP_ENV === "development" ? PRODUCTION_LIVE : PRODUCTION_LIVE;
export {DOMAIN_LIVE, DOMAIN, TLJ_DOMAIN, MEMBER_CENTER_DOMAIN, D11_DOMAIN, D11_BACK_END ,APATH,APRODUCTION};
